import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ProjectMemberAddPage } from '@/features/access/project-members/project-members-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

export const Route = createFileRoute('/$tenant/projects/$projectId/members/new')({
  component: AddMemberRoute,
});

function AddMemberRoute() {
  const { tenant, projectId } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      projectId={projectId}
      activeItem="overview"
      crumbs={[{ label: t('access.projectMembers.title') }, { label: t('access.projectMembers.addTitle') }]}
    >
      <ProjectMemberAddPage tenantId={tenant} projectId={projectId} />
    </ConsoleShell>
  );
}
